export const LINKS = {
    APP_STORE_LINK: 'https://apps.apple.com/bg/app/evrotrust/id1195807317',
    GOOGLE_PLAY_LINK: 'https://play.google.com/store/apps/details?id=com.evrotrust.app&hl=en&gl=US'
};
